import React, {useState, useEffect} from 'react';

import { useDispatch} from 'react-redux';

import { useHistory } from 'react-router-dom';

import PropTypes from 'prop-types';

import Tooltip from '@material-ui/core/Tooltip';

import { NavTopMenu } from '../shared/NavTopMenu';
import { Footer } from '../shared/Footer';
import { SidebarMenu } from '../shared/SidebarMenu';

import { sesionExpired } from '../../constants/auth/sesionExpired';
import { timeSessionDifference } from '../../constants/auth/timeSessionDifference';
import { actionErrorConnection } from "../../constants/component/actionErrorConnection";

import termsAndConditionsService from '../../services/termsAndConditions.service';

import '../../styles/style.scss';
import '../../styles/contentScreenStyle.scss';
import { validateAccessUser } from '../../constants/component/validateAccessUser';
import * as view from '../../constants/models/viewsList';
import { SYSTEM } from '../../constants/models/typeOperationRol';
import { useAuthInfo } from '../../utils/authUtils';
import NotFound from '../../constants/customComponent/NotFound';
import LoadingRowSpinner from '../../constants/customComponent/LoadingRowSpinner';
export const TermsAndConditionsScreen = (props) => {

  const {operationRol, userLogged: user} = useAuthInfo()
  const tokenExpired = process.env.REACT_APP_TIME_EXPIRED_TOKEN;
  const sessionDifference = timeSessionDifference();

  const dispatch = useDispatch();
  const history = useHistory();

  const [file, setFile] = useState({});
  const [isLoadingData, setIsLoadingData] = useState(true);

  /** 
   * Ejecuta una vez servicio para recuperar el archivo de términos y condiciones
   * -author Kenzo Sashida
   * -version 1.0.0 - Julio  2024
   * 
  */
  useEffect(() => {
    termsAndConditionsService.getFileTermsAndConditions().then((response)=>{
      setFile(response)
        setIsLoadingData(false)
  }).catch((error)=>{
      setFile({});
      setIsLoadingData(false);

      if(sessionDifference > Number(tokenExpired)){
          sesionExpired(dispatch, history);
        } else{
          actionErrorConnection(error);
        }
  });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);
  /**
   * Redireccionar a la pagina para crear archivo Terminos y Condiciones
   * @author Kenzo Sashida - ETE
   * @version 1.0.0 - Julio 2024
   */
  const getNewContent = () => {
    props.history.push('/administration/terms-and-conditions/create');
    window.location.reload();
  }

  /**
   * Realiza la descarga del archivo
   * @param { string } fileName - nombre del archivo
   * @param { string } file - data del archivo
   * @author Kenzo Sashida
   * @version 1.0.0 - Julio 2024
   */
  const downloadFile = (file,fileName) =>{
    const byteString = window.atob(file.split(',')[1]);
          const mimeString = file.split(',')[0].split(':')[1].split(';')[0];

          const ab = new ArrayBuffer(byteString.length);
          const ia = new Uint8Array(ab);
          for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i)
          }

          const dataBlob = new Blob([ab], { type: mimeString });

          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(dataBlob, `${fileName}`);
            return
          }
    
          const url = window.URL.createObjectURL(dataBlob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${fileName}`);
          document.body.appendChild(link);
          link.click();
          link.remove();
  };

    return (
        <>
          <div className="container-fluid p-0 m-0">
            <div className="row flex-nowrap p-0 m-0">
                <div className="col-auto col-md-3 col-xl-2 p-0 d-none d-sm-block">
                <SidebarMenu/>
                </div>
                <div className="col p-0 ms-1 me-1">
                  <NavTopMenu />
                  <div className="container ps-3 pe-3 container-size">
                    <div className="row base-container ">
                      <div className="col-12 border-title text-title pt-2 pb-2 ps-4 h4">
                        <span>T&eacute;rminos y Condiciones</span>
                      </div>
                      <div className="col-12 pt-3 pb-3 ps-4 pe-4">
                        <div className="row ">
                          <div className="container p-0">
                            <div className="row m-0">
                              <div className="col-12">
                                { (validateAccessUser(view.UPLOAD_TERMS_AND_CONDITIONS, user) && operationRol === SYSTEM) &&
                                  <div className="w-100 d-flex justify-content-end">
                                    <Tooltip title="Nuevo contenido" placement="top-start" arrow>
                                      <button className="btn custom-btn-icons" 
                                      type="button" 
                                      onClick={getNewContent}
                                      >
                                        <i className="fas fa-plus-square custom-icon-add"></i>
                                      </button>
                                      
                                    </Tooltip>
                                  </div>
                                }
                              </div>    
                              <div className="col-12">
                                <div className="row">
                                  { !isLoadingData && (file && Object.keys(file).length > 0 ?
                                    <div className='col-md-6 mb-3'>
                                      <div className="w-100 h-100 border-content-sections">
                                        <div className="row">
                                        <div className="col-md-9 pt-2">
                                          <div className="border-text-menu-title">
                                            <span className="text-title-section" >Archivos</span>
                                          </div>
                                        </div>
                                        </div>
                                        <div className="row pb-2 pt-2 ps-1 pe-1">
                                            <div className='col-md-12'>
                                              <div className="pt-1 pb-1 bg-file border-content-sections mb-2 ps-1">
                                                <div className="row p-0 m-0">
                                                  <div className="col-1 p-0 m-0 d-flex align-items-center align-items-md-start align-items-lg-center">
                                                    <i className={`far fa-file-pdf pdf-icon icon-list-size`}></i>
                                                  </div>
                                                  <div className="col-11 p-0 m-0">
                                                    <div className="row p-0 m-0">
                                                      <div className="col-8 col-md-12 col-lg-8 ps-md-2 ps-lg-1">
                                                        <span className="d-block text-title-document">T&eacute;rminos y Condiciones</span>
                                                        <span className="d-block text-sub-title-document">pdf</span>
                                                      </div>
                                                      <div className="col-4 col-md-12 col-lg-4 hide-btn-action">
                                                        <div className="d-flex align-items-center h-100">
                                                          <div className="w-100 d-flex justify-content-center">
                                                            <Tooltip title="Descargar" placement="top-start" arrow>
                                                              <button className="btn-list custom-btn-icons" 
                                                              type="button"
                                                              onClick={() => downloadFile(file.data,file.name)}
                                                              >
                                                                <i className="fas fa-cloud-download-alt"></i>
                                                              </button>
                                                            </Tooltip>
                                                            {(validateAccessUser(view.UPLOAD_TERMS_AND_CONDITIONS, user) && operationRol === SYSTEM) &&
                                                              <Tooltip title="Editar" placement="top-start" arrow>
                                                                <button className="btn-list custom-btn-icons" 
                                                                type="button" 
                                                                onClick={getNewContent}
                                                                >
                                                                  <i className="fas fa-edit"></i>
                                                                </button>
                                                              </Tooltip>
                                                            }
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                        </div>
                                      </div>
                                    </div>
                                  :
                                    <NotFound/>
                                  )}
                                  <LoadingRowSpinner isLoading={isLoadingData}/>
                                </div>
                              </div>                          
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
          <Footer/>
        </>
    )
}

TermsAndConditionsScreen.propTypes = {
  history: PropTypes.object
}
